import { useEffect } from "react";
import ExtendedError from "../ExtendedError";
import isError from "../isError";
import { useErrorReportingContext } from "./ErrorReportingContextProvider";
const flowErrorType = "FLOW_ERROR";
export class FlowErrorEvent {
    static dispatch(error) {
        document.dispatchEvent(new CustomEvent(flowErrorType, { detail: { error } }));
    }
    static useDispatch() {
        const context = useErrorReportingContext();
        return (error) => {
            const errorWithContext = isError(error)
                ? new ExtendedError({
                    cause: error,
                    info: context,
                }, error.message)
                : error;
            document.dispatchEvent(new CustomEvent(flowErrorType, {
                detail: {
                    error: errorWithContext,
                },
            }));
        };
    }
    static listen(handler) {
        document.addEventListener(flowErrorType, handler);
        return () => {
            document.removeEventListener(flowErrorType, handler);
        };
    }
    static useListen(handler) {
        useEffect(() => FlowErrorEvent.listen(handler), []);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxvd0Vycm9yRXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZXJyb3JzL2Vycm9yUmVwb3J0aW5nL0Zsb3dFcnJvckV2ZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFDbEMsT0FBTyxhQUFhLE1BQU0sa0JBQWtCLENBQUM7QUFDN0MsT0FBTyxPQUFPLE1BQU0sWUFBWSxDQUFDO0FBQ2pDLE9BQU8sRUFBRSx3QkFBd0IsRUFBRSxNQUFNLGlDQUFpQyxDQUFDO0FBRTNFLE1BQU0sYUFBYSxHQUFHLFlBQVksQ0FBQztBQVFuQyxNQUFNLE9BQU8sY0FBYztJQUNsQixNQUFNLENBQUMsUUFBUSxDQUFDLEtBQWM7UUFDbkMsUUFBUSxDQUFDLGFBQWEsQ0FDcEIsSUFBSSxXQUFXLENBQUMsYUFBYSxFQUFFLEVBQUUsTUFBTSxFQUFFLEVBQUUsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUN0RCxDQUFDO0lBQ0osQ0FBQztJQUVNLE1BQU0sQ0FBQyxXQUFXO1FBQ3ZCLE1BQU0sT0FBTyxHQUFHLHdCQUF3QixFQUFFLENBQUM7UUFFM0MsT0FBTyxDQUFDLEtBQUssRUFBRSxFQUFFO1lBQ2YsTUFBTSxnQkFBZ0IsR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDO2dCQUNyQyxDQUFDLENBQUMsSUFBSSxhQUFhLENBQ2Y7b0JBQ0UsS0FBSyxFQUFFLEtBQUs7b0JBQ1osSUFBSSxFQUFFLE9BQU87aUJBQ2QsRUFDRCxLQUFLLENBQUMsT0FBTyxDQUNkO2dCQUNILENBQUMsQ0FBQyxLQUFLLENBQUM7WUFFVixRQUFRLENBQUMsYUFBYSxDQUNwQixJQUFJLFdBQVcsQ0FBQyxhQUFhLEVBQUU7Z0JBQzdCLE1BQU0sRUFBRTtvQkFDTixLQUFLLEVBQUUsZ0JBQWdCO2lCQUN4QjthQUNGLENBQUMsQ0FDSCxDQUFDO1FBQ0osQ0FBQyxDQUFDO0lBQ0osQ0FBQztJQUVNLE1BQU0sQ0FBQyxNQUFNLENBQ2xCLE9BQTRDO1FBRTVDLFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxhQUFhLEVBQUUsT0FBTyxDQUFDLENBQUM7UUFDbEQsT0FBTyxHQUFHLEVBQUU7WUFDVixRQUFRLENBQUMsbUJBQW1CLENBQUMsYUFBYSxFQUFFLE9BQU8sQ0FBQyxDQUFDO1FBQ3ZELENBQUMsQ0FBQztJQUNKLENBQUM7SUFFTSxNQUFNLENBQUMsU0FBUyxDQUFDLE9BQTRDO1FBQ2xFLFNBQVMsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RELENBQUM7Q0FDRiJ9